import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  root: {
    background: '#fff',
  },
});

export default useStyles;
